import axios from "axios";

const i18n = axios.create({
  baseURL: process.env["VUE_APP_I18N_API"],
  headers: {},
});

export default async (locale) => {
  const response = await i18n.get(`/${locale}`);

  return response.data.keys;
};
